import {initRequestPushNotifications} from "../../common/requestPushNotifications";
import Axios from "axios";
import {toUrl} from "../../helpers/url";
import {deleteConfirmation, handleAjaxSuccess} from "../../helpers/SwalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initNotificationsSettingsIndex(forAdmin = true) {
	const requestPushNotifications = initRequestPushNotifications(forAdmin);

	const receiveNotificationsButton = document.querySelector('.receive-notifications-button');

	if (receiveNotificationsButton) {
		receiveNotificationsButton.onclick = requestPushNotifications.displayPrompt;
	}

	// Init delete buttons
	document.querySelectorAll('.remove-push-subscription-button').forEach(button => {
		button.onclick = () => removePushSubscription(button.dataset.id);
	})


	// Init notifications toggles
	document.querySelectorAll('.notification-toggle-checkbox').forEach(checkbox => {
		checkbox.onclick = handleCheckBoxChange;
	})


	/** Methods */

	function removePushSubscription(subscriptionId) {
		deleteConfirmation(
			'Are you sure want to stop receiving notifications on this device?',
			null,
			null,
			'Yes'
		).then(result => {
			if (result.value) {
				loading()

				let url = forAdmin ?
					`/admin/notifications-settings/push-subscriptions/${subscriptionId}/remove` :
					`/notifications-settings/push-subscriptions/${subscriptionId}/remove`

				Axios.post(toUrl(url))
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

	function handleCheckBoxChange(event) {

		const checkBox = event.currentTarget;

		const notificationKey = checkBox.name;

		loading();

		let url = forAdmin ?
			`/admin/notifications-settings/toggle-notification` :
			`/notifications-settings/toggle-notification`

		Axios.post(toUrl(url), {
			notification_key: notificationKey,
			new_value: checkBox.checked ? 1 : 0,
		})
			.then(response => {
				// No need to reload
				handleAjaxSuccess(response, () => {
				})
			}).catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initNotificationsSettingsIndex}
